import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { H4, H5, LI, UL } from "../../../../AbstractElements";
import { AllAbout, Href } from "../../../../Constants/Constants";
import { SearchTabData } from "../../../../Data/Applications/SearchResult/SearchResult";
import PagesSort from "./Pages";

const VideoTabs = () => {
  return (
    <Row>
      <Col xxl="6" className="box-col-12">
        <H4 className="my-3">{AllAbout}</H4>
        {SearchTabData.slice(0, 3).map((item) => (
          <div className="d-flex info-block" key={item.id}>
            <iframe className="me-3" width="200" height="100" src={item.videoLink} title="videos"></iframe>
            <div className="flex-grow-1">
              <Link to={Href}>{item.url}</Link>
              <H5>{item.title}</H5>
              <div className="star-ratings">
                <UL className="search-info simple-list flex-row">
                  <LI>{item.star}</LI>
                  <LI>{item.vote}</LI>
                  <LI>{item.news}</LI>
                </UL>
              </div>
            </div>
          </div>
        ))}
        <PagesSort pageClass="start" />
      </Col>
      <Col xxl="6" className="box-col-12">
        <H4 className="my-3">{AllAbout}</H4>
        {SearchTabData.slice(1, 4).map((item) => (
          <div className="d-flex info-block" key={item.id}>
            <iframe className="me-3" width="200" height="100" src={item.videoLink} title="videos"></iframe>
            <div className="flex-grow-1">
              <Link to={Href}>{item.url}</Link>
              <H5>{item.title}</H5>
              <div className="star-ratings">
                <UL className="search-info simple-list flex-row">
                  <LI>{item.star}</LI>
                  <LI>{item.vote}</LI>
                  <LI>{item.news}</LI>
                </UL>
              </div>
            </div>
          </div>
        ))}
      </Col>
    </Row>
  );
};
export default VideoTabs;
